export default __webpack_public_path__ + "static/media/studyMaterialIcon.a8929e38.svg";